module.exports = __webpack_public_path__ + "img/天府新区合江小学.4cea39af.jpg";